import React, { useEffect, useState } from 'react';
import './Toast.css';

/**
 * Toast notification component that displays temporary messages at the bottom of the screen.
 * @param {Object} props - Component properties
 * @param {string} props.message - The message to display in the toast
 * @param {boolean} props.isVisible - Whether the toast should be visible
 * @param {function} props.onClose - Callback function when toast closes
 * @param {number} props.duration - Duration in milliseconds before auto-close (provided by ToastContext)
 * @param {string} props.variant - Visual toast variant supplied by ToastContext.
 */
function Toast({ message, isVisible, onClose, duration, variant }) {
  const [isShowing, setIsShowing] = useState(false);

  useEffect(() => {
    if (isVisible) {
      setIsShowing(true);
      const timer = setTimeout(() => {
        setIsShowing(false);
        setTimeout(onClose, 300); // Wait for fade-out animation
      }, duration);

      return () => clearTimeout(timer);
    }
  }, [isVisible, duration, onClose]);

  if (!isVisible && !isShowing) {
    return null;
  }

  return (
    <div
      className={`toast toast-${variant} ${isShowing ? 'toast-visible' : 'toast-hidden'}`}
      role="status"
    >
      <span className="toast-message">{message}</span>
    </div>
  );
}

export default Toast;
